import React, { useEffect, useState, useRef } from "react";
import "../../../styles/Auth/pos.css"
import { deleteData, getData, postData, putData } from '../../../webService/webservice.js';
import { toast } from "react-toastify";
import AddCustomerForm from "../Customers/add-customerForm.jsx";
import InvoicePrint58 from "./InvoicePrint58.jsx";
import ReturnPrint58 from "./ReturnPrint58.jsx";
import { computeOfferRows } from "../../../utils/calcOfferPrice.js";

const POSPage = () => {
    const [printInvoice, setPrintInvoice] = useState(null);
    const [date, setDate] = useState(new Date());
    const [products, setProducts] = useState([]);
    const dropdownRef = useRef(null);
    // ---------- Defaults changed for consistency ----------
    const [overallDiscount, setOverallDiscount] = useState(0);
    const [overallDiscountType, setOverallDiscountType] = useState("%"); // was "Flat" -> use "%" to match UI
    const [showPaymentModal, setShowPaymentModal] = useState(false);
    const [pricePopup, setPricePopup] = useState(null);
    const [payments, setPayments] = useState([{ paymentMethod: "Cash", amount: 0 }]); // default one payment row
    const [customers, setCustomers] = useState([]);
    const [employees, setEmployees] = useState([]);
    const [salesBy, setSalesBy] = useState("");
    const [customerSearch, setCustomerSearch] = useState("");
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [showCustomerDropdown, setShowCustomerDropdown] = useState(false);
    const [showAddCustomerModal, setShowAddCustomerModal] = useState(false);
    const [customerMobile, setCustomerMobile] = useState("");
    const [availablePoints, setAvailablePoints] = useState("");
    const [customerAddress, setCustomerAddress] = useState("");
    const [productSearch, setProductSearch] = useState("");
    const [showProductDropdown, setShowProductDropdown] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [cartItems, setCartItems] = useState([]);
    const [previousBills, setPreviousBills] = useState([]);
    const [customerPoints, setCustomerPoints] = useState(0);
    const [customerBalance, setCustomerBalance] = useState(0);
    const [customerMemberNo, setCustomerMemberNo] = useState("-");
    const [customerDOB, setCustomerDOB] = useState("-");
    const [customerMargin, setCustomerMargin] = useState(0);
    const [customerMRP, setCustomerMRP] = useState(0);
    const [customerSaving, setCustomerSaving] = useState(0);
    const [offerMessage, setOfferMessage] = useState("");
    const [enableInvoiceInput, setEnableInvoiceInput] = useState(false);
    const [invoiceNumber, setInvoiceNumber] = useState("");
    const [invoiceInput, setInvoiceInput] = useState("");
    const [invoiceData, setInvoiceData] = useState(null);
    const [showPriceCheck, setShowPriceCheck] = useState(false);
    const [priceCheckInput, setPriceCheckInput] = useState("");
    const [priceCheckResult, setPriceCheckResult] = useState(null);
    const [showStockCheck, setShowStockCheck] = useState(false);
    const [stockInput, setStockInput] = useState("");
    const [stockResult, setStockResult] = useState([]);
    const [showRedeemModal, setShowRedeemModal] = useState(false);
    const [useRewardPoints, setUseRewardPoints] = useState(false);
    const [redeemPoints, setRedeemPoints] = useState(0);
    const [showReprintModal, setShowReprintModal] = useState(false);
    const [reprintInput, setReprintInput] = useState("");
    const [showPricePopup, setShowPricePopup] = useState(false);
    const [priceOptions, setPriceOptions] = useState([]);
    const [previewData, setPreviewData] = useState(null);
    const [stockOptions, setStockOptions] = useState([]);
    const [previewLoading, setPreviewLoading] = useState(false);
    const [walletUsed, setWalletUsed] = useState(0);
    // --- RETURN STATES ---
    const [returnPanelOpen, setReturnPanelOpen] = useState(false);
    const [returnInvoiceNo, setReturnInvoiceNo] = useState("");
    const [returnInvoice, setReturnInvoice] = useState(null);
    const [returnRemarks, setReturnRemarks] = useState("");
    const [returnPrintData, setReturnPrintData] = useState(null);
    const [returnLoading, setReturnLoading] = useState(false);
    const [refundToWallet, setRefundToWallet] = useState(false);
    const [priceCheckError, setPriceCheckError] = useState(null);
    const [stockError, setStockError] = useState(null);
    const [shouldPrint, setShouldPrint] = useState(false);

    const showOfferMessage = (msg) => {
        setOfferMessage(msg);
        setTimeout(() => setOfferMessage(""), 3000);
    };

    const resetReturnState = () => {
        setReturnPanelOpen(false);
        setReturnInvoiceNo("");
        setReturnInvoice(null);
        setReturnRemarks("");
        setRefundToWallet(false);
        setPreviewData(null);
    };

    useEffect(() => {
        if (shouldPrint && printInvoice) {
            setTimeout(() => {
                printInvoice58();
                setShouldPrint(false);
            }, 300); // small delay ensures DOM is ready
        }
    }, [shouldPrint, printInvoice]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowProductDropdown(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    // ----------------- Fetch Data -----------------
    useEffect(() => {
        const token = sessionStorage.getItem("sessionToken");
        const fetchProducts = async () => {
            try {
                const res = await getData("/products/products", {}, token);
                setProducts(res?.data?.[0]?.paginatedResults || []);
            } catch {
                setProducts([]);
            }
        };

        const fetchCustomers = async () => {
            try {
                const res = await getData("/customers/customers", {}, token);
                setCustomers(res?.data?.[0]?.paginatedResults || []);
            } catch {
                setCustomers([]);
            }
        };

        const fetchEmployees = async () => {
            try {
                const res = await getData("/users/users", {}, token);
                setEmployees(res?.data?.[0]?.paginatedResults || []);
            } catch (error) {
                setEmployees([]);
            }
        }
        fetchProducts();
        fetchCustomers();
        fetchEmployees();
    }, []);

    useEffect(() => {
        const timer = setInterval(() => {
            setDate(new Date());
        }, 60 * 1000);
        return () => clearInterval(timer);
    }, []);

    const formattedDate = date.toISOString().split("T")[0];

    const filteredProducts = products?.filter(item =>
        (item.productType === "Offline" || item.productType === "Both") && (
            item.title?.toLowerCase().includes(productSearch.toLowerCase()) ||
            item.productCode?.toLowerCase().includes(productSearch.toLowerCase()) ||
            item.barCode?.toLowerCase().includes(productSearch.toLowerCase())
        )
    );

    // ----------------- Helper: recompute single row's value -----------------
    const recomputeItemValue = (item) => {
        const subtotal = (Number(item.rate) || 0) * (Number(item.qty) || 0);
        const discount = item.discType === "%"
            ? (subtotal * Number(item.disc || 0)) / 100
            : Number(item.disc || 0);
        return subtotal - discount;
    };

    // ----------------- Cart utilities -----------------
    // Merge incoming rows into cart (merge by productId + rate + isFree flag)
    const addRowsToCart = (rows) => {
        setCartItems(prev => {
            const copy = [...prev];
            rows.forEach(row => {
                // normalize fields
                row.qty = Number(row.qty || 1);
                row.rate = Number(row.rate || 0);
                row.discType = row.discType || "%";
                row.disc = Number(row.disc || 0);
                row.tax = Number(row.tax || 0);
                row.isFree = !!row.isFree;

                // find existing by productId + rate + isFree
                const idx = copy.findIndex(ci =>
                    String(ci.productId) === String(row.productId) &&
                    Number(ci.rate) === Number(row.rate) &&
                    !!ci.isFree === !!row.isFree
                );

                if (idx > -1) {
                    // merge qty & recompute value
                    copy[idx].qty = Number(copy[idx].qty || 0) + Number(row.qty || 0);
                    copy[idx].value = recomputeItemValue(copy[idx]);
                } else {
                    // new row: compute value and push
                    const newRow = {
                        productId: row.productId,
                        barcode: row.barcode || row.barcode || "",
                        name: row.name || row.title || "Unknown",
                        unit: row.unit || "PCS",
                        qty: Number(row.qty || 1),
                        rate: Number(row.rate || 0),
                        tax: Number(row.tax || 0),
                        discType: row.discType || "%",
                        disc: Number(row.disc || 0),
                        value: 0,
                        isFree: !!row.isFree,
                        offerApplied: row.offerApplied || null,
                        flatOfferDetails: row.flatOfferDetails || null,   // <-- ADD THIS
                        originalRate: row.originalRate || row.rate        // <-- ADD THIS
                    };
                    newRow.value = recomputeItemValue(newRow);
                    copy.push(newRow);
                }
            });
            return copy;
        });
    };

    // ----------------- Product selection (with offers & stock) -----------------
    // const handleProductSelect = async (p) => {
    //     setShowProductDropdown(false);
    //     setProductSearch("");

    //     const token = sessionStorage.getItem("sessionToken");

    //     // 1️⃣ Fetch offers
    //     let offerData = [];
    //     try {
    //         const res = await getData(`comboOffers/comboOffer/offers/${p._id}`, {}, token);
    //         offerData = res?.data?.offers || [];
    //     } catch (err) {
    //         console.log("Offer fetch error:", err);
    //     }

    //     // ⭐ CHECK FOR FLAT OFFER → productId must match
    //     const flatOffer = offerData.find(o =>
    //         o.offerType === "FlatOffer" &&
    //         o.productIds.includes(p._id) &&
    //         o.isActive
    //     );

    //     // ⭐ VALID DATE CHECK
    //     let offerValid = false;

    //     if (flatOffer) {
    //         const now = new Date();
    //         const start = new Date(flatOffer.offerStartDate);
    //         const end = new Date(flatOffer.offerEndDate);

    //         offerValid = now >= start && now <= end;
    //     }

    //     // 2️⃣ Fetch stock entries
    //     let stockEntries = [];
    //     try {
    //         const s = await getData(`/stocks/stock/product/${p._id}`, {}, token);
    //         stockEntries = s.data || [];
    //     } catch (err) {
    //         console.log("Stock fetch error:", err);
    //     }

    //     // ⭐ APPLY FLAT OFFER
    //     let rows;

    //     if (flatOffer && offerValid) {

    //         const qty = 1; // initial qty

    //         if (qty >= flatOffer.flatQuantity) {
    //             // Apply offer price
    //             showOfferMessage(
    //                 `${flatOffer.offerName} Applied! Price ₹${flatOffer.offerPrice}`
    //             );

    //             rows = [{
    //                 productId: p._id,
    //                 name: p.title,
    //                 qty: qty,
    //                 rate: Number(flatOffer.offerPrice),
    //                 amount: Number(flatOffer.offerPrice),
    //                 offerApplied: flatOffer.offerName
    //             }];
    //         } else {
    //             // Quantity not enough
    //             const need = flatOffer.flatQuantity - qty;

    //             showOfferMessage(
    //                 `Add ${need} more to activate ${flatOffer.offerName}`
    //             );

    //             // Normal compute without offer
    //             rows = computeOfferRows(p, qty, [], stockEntries);
    //         }
    //     } 
    //     else {
    //         // Normal non-flat-offer flow
    //         rows = computeOfferRows(p, 1, offerData, stockEntries);
    //     }

    //     // 4️⃣ Process FREE products if any
    //     for (let r of rows) {
    //         if (r.isFreeProductPlaceholder) {
    //             try {
    //                 const freeRes = await getData(`/products/product/${r.productId}`, {}, token);
    //                 const freeProduct = freeRes.data;

    //                 r.barcode = freeProduct.productCode;
    //                 r.name = (freeProduct.title || "Free Item") + " (FREE)";
    //                 r.unit = freeProduct.unit || "PCS";
    //                 r.rate = 0;
    //                 r.qty = Number(r.qty || 0);
    //                 r.isFree = true;

    //                 delete r.isFreeProductPlaceholder;
    //             } catch (err) {
    //                 console.log("Failed to fetch free product details", err);
    //             }
    //         }
    //     }

    //     // 5️⃣ Add rows to cart
    //     addRowsToCart(rows);
    // };

    const handleBarcodeTyping = (value) => {
        setProductSearch(value);
        setShowProductDropdown(true);

        // 🔥 If length >= 8 → attempt auto-select
        if (value.length >= 8) {
            const match = products.find(p =>
                String(p.productCode).toLowerCase() === value.toLowerCase()
            );

            if (match) {
                handleProductSelect(match);  // auto add to cart
                setSelectedProduct(match);
                setProductSearch("");        // clear search
                setShowProductDropdown(false);
            }
        }
    };

    const preparePriceOptions = (stocks) => {
        const validStocks = stocks.filter(
            s =>
            s.isActive &&
            s.type === "Purchase" &&
            s.offlineQuantity > 0
        );

        // group by sellingPrice
        const priceMap = {};

        validStocks.forEach(stock => {
            if (!priceMap[stock.sellingPrice]) {
            priceMap[stock.sellingPrice] = [];
            }
            priceMap[stock.sellingPrice].push(stock);
        });

        // convert to array
        return Object.keys(priceMap).map(price => ({
            sellingPrice: Number(price),
            stocks: priceMap[price],
            totalQty: priceMap[price].reduce(
            (sum, s) => sum + s.offlineQuantity,
            0
            )
        }));
    };

    const handleProductSelect = async (p) => {
        setShowProductDropdown(false);
        setProductSearch("");

        const token = sessionStorage.getItem("sessionToken");

        try {
            // 🔥 1️⃣ Fetch stock details by productId
            const stockRes = await getData(
                `stocks/stock/product/${p._id}`,
                {},
                token
            );

            const stocks = stockRes?.data || [];

            if (!stocks.length) {
                alert("No stock available for this product");
                return;
            }
            
            // 🔥 2️⃣ Filter available stock only
            const availableStocks = stocks.filter(s => s.offlineQuantity > 0);

            if (!availableStocks.length) {
                alert("Stock is out of stock");
                return;
            }

            // 🔥 3️⃣ Extract unique selling prices
            const uniquePrices = [
                ...new Set(availableStocks.map(s => s.sellingPrice))
            ];

            // 🔥 4️⃣ Multiple prices → popup
            if (uniquePrices.length > 1) {
                setSelectedProduct(p);
                const priceOptions = preparePriceOptions(stocks);

                if (priceOptions.length > 1) {
                    setSelectedProduct(p);
                    setStockOptions(priceOptions); // 🔥 grouped by price
                    setShowPricePopup(true);
                    return;
                }
                return;
            }

            // 🔥 5️⃣ Single price → auto select
            const selectedStock = availableStocks[0];

            await addProductToCartWithStock(
                p,
                selectedStock,
                token
            );

        } catch (err) {
            console.error("Stock fetch failed", err);
            alert("Failed to fetch stock details");
        }
    };

    const addProductToCartWithStock = (product, stock) => {

        const row = {
            productId: product._id,
            barcode: product.productCode,
            name: product.title,
            unit: product.unit || "PCS",

            qty: 1,

            // 🔥 THIS is the key — same price rows will merge automatically
            rate: Number(stock.sellingPrice),

            tax: Number(product.tax || 0),
            discType: "%",
            disc: 0,

            isFree: false,

            // optional (safe to keep)
            originalRate: stock.sellingPrice,

            // ⚠️ DO NOT put stockId in merge keys
            // keep it only for backend payload if needed
            stockId: stock._id,
            batchNo: stock.batchNo
        };

        // ✅ LET YOUR EXISTING LOGIC HANDLE MERGE
        addRowsToCart([row]);
    };



    // const handleProductSelect = async (p) => {
    //     setShowProductDropdown(false);
    //     setProductSearch("");

    //     const token = sessionStorage.getItem("sessionToken");

    //     // Fetch offers for this product
    //     let offerData = [];
    //     try {
    //         const res = await getData(`comboOffers/comboOffer/offers/${p._id}`, {}, token);
    //         offerData = res?.data?.offers || [];
    //     } catch (err) { }

    //     // Find active flat offer
    //     const flatCombo = offerData.find(o =>
    //         o.offerType === "FlatOffer" &&
    //         o.productIds.map(id => String(id)).includes(String(p._id)) &&
    //         o.isActive
    //     );

    //     let validFlat = false;

    //     if (flatCombo) {
    //         const now = new Date();
    //         const start = new Date(flatCombo.offerStartDate);
    //         const end = new Date(flatCombo.offerEndDate);
    //         validFlat = now >= start && now <= end;
    //     }

    //     // Add product normally
    //     let rows = [{
    //         productId: p._id,
    //         barcode: p.productCode,
    //         name: p.title,
    //         unit: p.unit || "PCS",
    //         qty: 1,
    //         rate: p.sellingPrice || p.price || 0,
    //         tax: p.tax || 0,
    //         discType: "%",
    //         disc: 0,
    //         value: p.sellingPrice || p.price || 0
    //     }];

    //     addRowsToCart(rows);

    //     // After adding one product — apply combo logic
    //     setTimeout(() => {
    //         if (validFlat) applyFlatComboOffer(flatCombo);
    //     }, 100);
    // };

    const applyFlatComboOffer = (flatCombo) => {
        if (!flatCombo) return;

        setCartItems(prev => {
            let items = [...prev];

            const comboProductIds = flatCombo.productIds.map(id => String(id));

            // 1️⃣ Collect combo items
            const comboItems = items.filter(i =>
                comboProductIds.includes(String(i.productId))
            );

            const totalQty = comboItems.reduce((sum, i) => sum + Number(i.qty), 0);

            const comboQty = flatCombo.flatQuantity;
            const offerPrice = flatCombo.offerPrice;

            // 2️⃣ Not enough qty → remove offer
            if (totalQty < comboQty) {
                return items.map(i => {
                    if (comboProductIds.includes(String(i.productId))) {
                        i.offerApplied = null;
                        i.value = i.qty * (i.originalRate || i.rate);
                    }
                    return i;
                });
            }

            // 3️⃣ How many full combos apply?
            const combos = Math.floor(totalQty / comboQty);
            const extraQty = totalQty % comboQty;

            // 4️⃣ Calculate distributed values
            let remainingComboQty = combos * comboQty;

            items = items.map(i => {
                if (!comboProductIds.includes(String(i.productId))) {
                    return i;
                }

                const originalRate = i.originalRate || i.rate;
                const qty = i.qty;

                let value = 0;

                if (remainingComboQty > 0) {
                    const applyQty = Math.min(qty, remainingComboQty);
                    const comboValuePerItem = offerPrice / comboQty;

                    // Apply combo pricing (value only)
                    value += applyQty * comboValuePerItem;
                    remainingComboQty -= applyQty;

                    // Apply original pricing for remaining
                    const remaining = qty - applyQty;
                    value += remaining * originalRate;

                    i.offerApplied = flatCombo.offerName;
                } else {
                    // All items beyond combo → normal pricing
                    value = qty * originalRate;
                    i.offerApplied = null;
                }

                i.value = value;
                return i;
            });

            showOfferMessage(`${flatCombo.offerName} applied!`);
            return items;
        });
    };

    // ----------------- update qty / discount handlers (reuse your logic but ensure recompute) -----------------
    // const updateQty = (index, qtyIn) => {
    //     const qty = Number(qtyIn || 0);
    //     setCartItems(prev => {
    //         const updated = [...prev];
    //         const item = { ...updated[index] };
    //         item.qty = qty;
    //         item.value = recomputeItemValue(item);
    //         updated[index] = item;
    //         return updated;
    //     });
    // };

    const updateQty = (index, qtyIn) => {
        const qty = Number(qtyIn || 0);

        setCartItems(prev => {
            let updated = [...prev];

            // update row qty
            const item = { ...updated[index] };
            item.qty = qty;
            item.value = recomputeItemValue(item);
            updated[index] = item;

            return updated;
        });

        // 🔥 REAPPLY COMBO AFTER SETTING QTY
        setTimeout(() => {
            reapplyFlatComboIfNeeded();
        }, 10);
    };

    const reapplyFlatComboIfNeeded = async () => {
        const token = sessionStorage.getItem("sessionToken");

        // 1. Collect unique product IDs
        const productIds = Array.from(new Set(cartItems.map(i => String(i.productId))));

        // 2. Fetch offers for each product
        let allOffers = [];
        for (let pid of productIds) {
            try {
                const res = await getData(`comboOffers/comboOffer/offers/${pid}`, {}, token);
                if (res?.data?.offers) {
                    allOffers.push(...res.data.offers);
                }
            } catch (err) {
                console.log("Offer fetch error:", err);
            }
        }

        // 3. Filter flat + active + date-valid
        const now = new Date();
        const flatOffers = allOffers.filter(o => {
            const start = new Date(o.offerStartDate);
            const end = new Date(o.offerEndDate);
            return (
                o.offerType === "FlatOffer" &&
                o.isActive &&
                now >= start &&
                now <= end
            );
        });

        if (flatOffers.length === 0) return;

        // 4. Find *only* the flat offer that matches products in cart
        const matchingOffers = flatOffers.filter(o =>
            o.productIds.some(id =>
                productIds.includes(String(id))
            )
        );

        if (matchingOffers.length === 0) return;

        // 5. Choose correct flat offer
        const flatCombo = matchingOffers[0];

        // 6. CHECK QUANTITY REQUIREMENT
        const comboQty = cartItems
            .filter(i => flatCombo.productIds.includes(i.productId))
            .reduce((sum, i) => sum + Number(i.qty), 0);

        if (comboQty < flatCombo.flatQuantity) {
            // ❌ Not enough items → don't apply
            applyFlatComboOffer(null);
            return;
        }

        // 7. APPLY combo correctly
        applyFlatComboOffer(flatCombo);
    };

    const updateDiscType = (index, type) => {
        setCartItems(prev => {
            const updated = [...prev];
            const item = { ...updated[index] };
            item.discType = type;
            item.value = recomputeItemValue(item);
            updated[index] = item;
            return updated;
        });
    };

    const updateDisc = (index, discIn) => {
        const disc = Number(discIn || 0);
        setCartItems(prev => {
            const updated = [...prev];
            const item = { ...updated[index] };
            item.disc = disc;
            item.value = recomputeItemValue(item);
            updated[index] = item;
            return updated;
        });
    };

    const removeCartItem = (index) => {
        setCartItems(prev => {
            const updated = prev.filter((_, i) => i !== index);
            return updated;
        });

        setTimeout(() => {
            reapplyFlatComboIfNeeded();
        }, 10);
    };

    useEffect(() => {
        async function fetchNextInvoice() {
            try {
                const res = await getData("invoices/next-number");

                if (res?.nextInvoiceNo) {
                    setInvoiceNumber(res.nextInvoiceNo);
                }
            } catch (error) {
                console.error("Error fetching next invoice number:", error);
            }
        }

        fetchNextInvoice();
    }, []);

    // ----------------- Totals calculation (robust) -----------------
    // const calculateTotals = () => {
    //     console.log(cartItems);
    //     const items = cartItems.length;
    //     const qty = cartItems.reduce((sum, item) => sum + Number(item.qty || 0), 0);

    //     const computeItemValue = (item) => recomputeItemValue(item);

    //     const salesValue = cartItems.reduce((sum, item) => sum + computeItemValue(item), 0);

    //     const overallDiscAmount =
    //         overallDiscountType === "%"
    //             ? (salesValue * Number(overallDiscount || 0)) / 100
    //             : Number(overallDiscount || 0);

    //     const grossValue = salesValue - overallDiscAmount;

    //     let totalCGST = 0;
    //     let totalSGST = 0;

    //     cartItems.forEach((item) => {
    //         const gstRate = Number(item.tax || 0);
    //         const itemValue = computeItemValue(item);

    //         if (gstRate > 0) {
    //             const basePrice = itemValue / (1 + gstRate / 100);
    //             const gstAmt = itemValue - basePrice;
    //             totalCGST += gstAmt / 2;
    //             totalSGST += gstAmt / 2;
    //         }
    //     });

    //     const netValue = grossValue;

    //     const totalMRP = cartItems.reduce((sum, item) => {
    //         const mrpRate = Number(item.mrp || item.rate || 0);
    //         return sum + mrpRate * Number(item.qty || 0);
    //     }, 0);

    //     const saving = totalMRP - netValue;

    //     return {
    //         items,
    //         qty,
    //         salesValue,
    //         grossValue,
    //         netValue,
    //         totalCGST,
    //         totalSGST,
    //         totalMRP,
    //         saving,
    //         overallDiscAmount,
    //         overallDiscount,
    //         overallDiscountType
    //     };
    // };

    const calculateTotals = () => {
        const items = cartItems.length;

        // 🔥 Total QTY
        const qty = cartItems.reduce(
            (sum, item) => sum + Number(item.qty || 0),
            0
        );

        // 🔥 Sales value = sum of ONLY item.value (combo-friendly)
        const salesValue = cartItems.reduce(
            (sum, item) => sum + Number(item.value || 0),
            0
        );

        // 🔥 Apply overall discount
        const overallDiscAmount =
            overallDiscountType === "%"
                ? (salesValue * Number(overallDiscount || 0)) / 100
                : Number(overallDiscount || 0);

        const taxableValue = salesValue - overallDiscAmount;

        // ---------------------------------------
        // 🔥 GST CALCULATION (5% TOTAL)
        // CGST = 2.5%
        // SGST = 2.5%
        // ---------------------------------------

        const totalGST = taxableValue * 0.05;   // 5%
        const totalCGST = totalGST / 2;         // 2.5%
        const totalSGST = totalGST / 2;         // 2.5%

        const netValue = taxableValue; // same as taxable total

        // 🔥 MRP Calculation (rate * qty, since rate never changes)
        const totalMRP = cartItems.reduce((sum, item) => {
            const mrpRate = Number(item.mrp || item.rate || 0);
            return sum + (mrpRate * Number(item.qty || 0));
        }, 0);

        const saving = totalMRP - netValue;

        return {
            items,
            qty,
            salesValue,
            grossValue: taxableValue,
            netValue,
            totalCGST,
            totalSGST,
            totalMRP,
            saving,
            overallDiscAmount,
            overallDiscount,
            overallDiscountType
        };
    };

    const totals = calculateTotals();

    const maxRedeemablePoints = Math.min(
        Number(availablePoints || 0),
        Math.floor(Number(totals.netValue || 0))
    );

    const redeemAmount = useRewardPoints ? Number(redeemPoints || 0) : 0;

    useEffect(() => {
        if (!selectedCustomer) return;

        const walletBalance = Number(selectedCustomer.walletBalance || 0);

        // Net after reward redemption
        const netAfterRewards = Math.max(
            Number(totals.netValue || 0) - redeemAmount,
            0
        );

        const autoWalletUse = Math.min(walletBalance, netAfterRewards);

        setWalletUsed(autoWalletUse);

        setPayments(prev => {
            const others = prev.filter(p => p.paymentMethod !== "Wallet");

            if (autoWalletUse > 0) {
                return [...others, { paymentMethod: "Wallet", amount: autoWalletUse }];
            }
            return others;
        });

    }, [selectedCustomer, totals.netValue, redeemAmount]);

    const payableAmount = Math.max(
        Number(totals.netValue || 0) - redeemAmount - walletUsed,
        0
    );

    // ----------------- Invoice creation & printing (unchanged logic, minor fixes) -----------------
    const handleCreateInvoice = async () => {
        try {
            const token = sessionStorage.getItem("sessionToken");

            if (cartItems.length === 0) {
                return toast.error("Please add products before billing.");
            }

            // ⭐ Prepare items cleanly
            const processedItems = cartItems.map(item => {
                const qty = Number(item.qty) || 0;
                const rate = item.isFree ? 0 : Number(item.rate) || 0;
                const value = item.isFree ? 0 : Number(item.value) || (qty * rate);

                // 🔥 Build priceBreakup
                let priceBreakup = [];

                if (item.offerApplied && item.offerType === "FlatOffer" && item.comboOfferId) {
                    // This item is part of a combo  
                    const comboQty = item.flatQty || item.flatQuantity || item.flatOfferDetails?.flatQuantity || 2; // fallback  
                    const comboPrice = item.flatPrice || item.offerPrice || item.flatOfferDetails?.offerPrice || rate * comboQty;

                    const totalQty = qty;
                    const noOfCombos = Math.floor(totalQty / comboQty);
                    const leftover = totalQty % comboQty;

                    // Combo part
                    if (noOfCombos > 0) {
                        priceBreakup.push({
                            type: "combo",
                            qty: noOfCombos * comboQty,
                            rate: comboPrice / comboQty
                        });
                    }

                    // Normal leftover part
                    if (leftover > 0) {
                        priceBreakup.push({
                            type: "normal",
                            qty: leftover,
                            rate: item.originalRate || rate
                        });
                    }

                } else {
                    // Normal item (not part of any combo)
                    priceBreakup.push({
                        type: "normal",
                        qty,
                        rate
                    });
                }

                return {
                    productId: item.productId,
                    barcode: item.barcode || "",
                    name: item.name,
                    unit: item.unit,
                    qty,
                    rate,
                    tax: Number(item.tax) || 0,
                    discType: item.discType || "%",
                    disc: Number(item.disc || 0),
                    value,

                    // Combo offer fields
                    offerApplied: item.offerApplied || null,
                    offerType: item.offerType || null,
                    comboOfferId: item.comboOfferId || null,
                    isFree: item.isFree || false,
                    originalRate: item.originalRate
                        ? Number(item.originalRate)
                        : Number(item.rate) || 0,
                    returnedQty: 0,
                    batchDetails: []
                };
            });

            // ⭐ Build payload
            const payload = {
                customerId: selectedCustomer?._id || null,
                customerName: selectedCustomer?.name || "",
                customerPhone: selectedCustomer?.phoneNumber || "",
                customerAddress: customerAddress || "",
                items: processedItems,
                totals: {
                    ...totals,
                    redeemAmount,
                    payableAmount
                },
                redeem: {
                    pointsUsed: useRewardPoints ? redeemPoints : 0,
                    amount: redeemAmount
                },
                payments: payments.map(p => ({
                    paymentMethod: p.paymentMethod,
                    amount: Number(p.amount)
                })),
                salesBy: salesBy || null
            };
            console.log(payload);
            // ⭐ Create Invoice
            const res = await postData("/invoices/", payload, token);

            if (res?.data) {
                toast.success("Invoice Created Successfully");

                setPrintInvoice({
                    ...res.data,
                    isDuplicate: true
                });
                setShowPaymentModal(false);

                setTimeout(() => {
                    printInvoice58();
                }, 300);

                // Reset POS screen
                setCartItems([]);
                setPayments([{ paymentMethod: "Cash", amount: 0 }]);
                setCustomerAddress("");
                setCustomerBalance(0);
                setSelectedCustomer(null);
                setCustomerSearch("");
                setPreviousBills([]);
                setCustomerMobile("");
                setAvailablePoints(0);
                setUseRewardPoints(false);
                setRedeemPoints(0);
            }

        } catch (err) {
            console.error("Invoice error:", err);
            toast.error("Invoice Creation Failed");
        }
    };

    const printInvoice58 = () => {
        const el = document.getElementById("invoice-print-area");
        if (!el) return;
        const printContent = el.innerHTML;
        const printWindow = window.open("", "", "width=300,height=600");
        printWindow.document.write(`
            <html>
                <head>
                    <title>Invoice</title>
                    <style>
                        @page { size: 58mm auto; margin: 0; }
                        body { width:58mm; margin:0; padding:0; font-family: Arial; font-size:11px; }
                    </style>
                </head>
                <body>${printContent}</body>
            </html>
        `);
        printWindow.document.close();
        setTimeout(() => {
            printWindow.print();
            printWindow.close();
        }, 500);
    };

    const handleOkPrint = () => {
        if (cartItems.length === 0) {
            alert("Please add products first!");
            return;
        }
        setShowPaymentModal(true);
    };

    const handleReturn = () => {
        setEnableInvoiceInput(true);
        setInvoiceNumber("");
        setCartItems([]);
        setSelectedCustomer(null);
    };

    const handleCancelBill = () => {
        if (!window.confirm("Cancel the current bill?")) return;

        setCartItems([]);
        setSelectedCustomer(null);
        setCustomerSearch("");
        setCustomerAddress("");
        setCustomerMobile("");
        setAvailablePoints(0)
        setOverallDiscount(0);
        setPayments([{ paymentMethod: "Cash", amount: 0 }]);
        setEnableInvoiceInput(false);
    };

    useEffect(() => {
        const handleKeys = (e) => {
            if (e.key === "F1") { e.preventDefault(); handleOkPrint(); }
            if (e.key === "F2") { e.preventDefault(); handleReturn(); }
            if (e.key === "F3") { e.preventDefault(); handleCancelBill(); }
            if (e.key === "F4") { e.preventDefault(); setCartItems([]); }
            if (e.key === "F5") { e.preventDefault(); setShowPriceCheck(true); }
            if (e.key === "F6") { e.preventDefault(); setShowStockCheck(true); }
            if (e.key === "F7") { e.preventDefault(); setShowRedeemModal(true); }
            if (e.key === "F8") { e.preventDefault(); setShowReprintModal(true); }
        };

        window.addEventListener("keydown", handleKeys);
        return () => window.removeEventListener("keydown", handleKeys);
    }, []);

    // useEffect(() => {
    //     if (!enableInvoiceInput) return;

    //     if (invoiceNumber.length < 8) return; // wait until user types enough

    //     const timer = setTimeout(() => {
    //         loadReturnInvoice(invoiceNumber);
    //     }, 600); // small debounce

    //     return () => clearTimeout(timer);
    // }, [invoiceNumber, enableInvoiceInput]);

    const loadReturnInvoice = async () => {
        if (!returnInvoiceNo) return toast.error("Enter Invoice No");

        const token = sessionStorage.getItem("sessionToken");

        try {
            const res = await getData(`invoices/invoice/${returnInvoiceNo}`, {}, token);
            if (!res?.data) {
                toast.error("Invoice not found");
                return;
            }

            // Attach qtyReturned = 0 to each item
            const inv = {
                ...res.data,
                items: res.data.items.map(i => ({ ...i, qtyReturned: 0 }))
            };

            setReturnInvoice(inv);
        } catch (err) {
            toast.error("Invoice not found");
        }
    };

    const handlePreviewReturn = async () => {
        try {
            setPreviewLoading(true);

            const token = sessionStorage.getItem("sessionToken");

            const itemsToReturn = returnInvoice.items
            .filter(i => i.qtyReturned > 0)
            .map(i => ({
                productId: i.productId,
                qtyReturned: i.qtyReturned
            }));

            if (!itemsToReturn.length) {
                setPreviewLoading(false);
                return toast.error("Select at least one item to preview");
            }

            const res = await postData(
                "/salesReturns/preview",
                {
                    invoiceId: returnInvoice._id,
                    items: itemsToReturn
                },
                token
            );

            setPreviewData(res.data);
            setPreviewLoading(false);

        } catch (err) {
            setPreviewLoading(false);
            toast.error("Preview failed");
        }
    };

    const processReturn = async () => {
        try {
            const token = sessionStorage.getItem("sessionToken");

            const items = returnInvoice.items
                .filter(i => i.qtyReturned > 0)
                .map(i => ({
                    productId: i.productId,
                    qtyReturned: i.qtyReturned
                }));

            if (!items.length) {
                return toast.error("No items selected");
            }

            const res = await postData(
                "/salesReturns/create",
                {
                    invoiceId: returnInvoice._id,
                    items,
                    remarks: returnRemarks,
                    refundToWallet
                },
                token
            );

            toast.success("Return processed successfully");

            // ✅ STORE RETURN DATA FOR PRINT
            setReturnPrintData(res.data);

            // ✅ WAIT FOR DOM → THEN PRINT
            setTimeout(() => {
                printReturn58();
            }, 300);

            // ✅ RESET AFTER PRINT
            resetReturnState();

        } catch (err) {
            console.error(err);
            toast.error("Return failed");
        }
    };
    
    const printReturn58 = () => {
        const el = document.getElementById("return-print-area");
        if (!el) return;

        const printContent = el.innerHTML;
        const printWindow = window.open("", "", "width=300,height=600");

        printWindow.document.write(`
            <html>
                <head>
                    <title>Return Slip</title>
                    <style>
                        @page { size: 58mm auto; margin: 0; }
                        body { width: 58mm; margin: 0; padding: 0; font-family: Courier; }
                    </style>
                </head>
                <body>${printContent}</body>
            </html>
        `);

        printWindow.document.close();
        setTimeout(() => {
            printWindow.print();
            printWindow.close();
        }, 500);
    };

    // ----------------- JSX (mostly same as your existing) -----------------
    return (
        <div className="pos-page">
            <div className="pos-container">
                <div className="pos-logo"><img src="/assets/mayura.png" alt="Logo" /></div>
                <div className="pos-wrapper">
                    <div className="pos-left">
                        {/* Invoice & Customer Section */}
                        <div className="invoice-section">
                            <div className="info-block">
                                <div className="form-group">
                                    <label>Invoice no:</label>
                                    <input
                                        type="text"
                                        placeholder="Enter Invoice Number"
                                        className="form-control"
                                        value={invoiceNumber}
                                        onChange={(e) => setInvoiceNumber(e.target.value)}
                                        disabled={!enableInvoiceInput}
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Billing Date</label>
                                    <div className="date-time-row">
                                        <input type="date" value={formattedDate} readOnly />
                                    </div>
                                </div>
                            </div>

                            <div className="pos-divider"></div>

                            <div className="info-block" style={{ position: "relative" }}>
                                <div className="form-group">
                                    <label>Customer</label>
                                    <input
                                        type="text"
                                        placeholder="Search Customer"
                                        className="form-group1"
                                        value={customerSearch}
                                        onFocus={() => !selectedCustomer && setShowCustomerDropdown(true)}
                                        onChange={(e) => {
                                            setCustomerSearch(e.target.value);
                                            if (!selectedCustomer) setShowCustomerDropdown(true);
                                        }}
                                        style={{ paddingRight: "35px", width: "92%" }}
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Phone Number</label>
                                    <input className="form-group1" value={customerMobile} readOnly />
                                </div>

                                {selectedCustomer && (
                                    <button type="button" onClick={() => {
                                        setSelectedCustomer(null);
                                        setCustomerSearch("");
                                        setCustomerAddress("");
                                        setAvailablePoints(0);
                                        setCustomerBalance(0);
                                        setCustomerMobile("");
                                        setPreviousBills([]);
                                        setShowCustomerDropdown(false);
                                    }} style={{
                                        position: "absolute", right: "0px", top: "32%", transform: "translateY(-50%)",
                                        background: "transparent", color: "#555", fontSize: "16px", border: "none", cursor: "pointer",
                                        fontWeight: "600", lineHeight: "1",
                                    }}>
                                        ✕
                                    </button>
                                )}
                            </div>

                            {showCustomerDropdown && customerSearch && !selectedCustomer && (
                                <div className="pos-dropdown">
                                    {customers
                                        .filter((c) => {
                                            const search = customerSearch.toLowerCase();
                                            return (c?.name?.toLowerCase().includes(search) || String(c?.phoneNumber || "").includes(search));
                                        })
                                        .map((c, idx) => (
                                            <div key={idx} className="pos-dropdown-item" onClick={async () => {
                                                setSelectedCustomer(c);
                                                setCustomerSearch(`${c.name || ""} (${c.phoneNumber})`);
                                                setShowCustomerDropdown(false);
                                                setAvailablePoints(c.rewardPoints);
                                                setCustomerMobile(c.phoneNumber);
                                                setCustomerAddress(c.address || c.city || "");
                                                try {
                                                    const token = sessionStorage.getItem("sessionToken");
                                                    const billRes = await getData(`/invoices/customer/${c._id}/invoices`, {}, token);
                                                    setPreviousBills(billRes.data || []);
                                                } catch (err) {
                                                    setPreviousBills([]);
                                                }
                                                setCustomerPoints(c.points || 0);
                                                setCustomerBalance(c.walletBalance);
                                                setCustomerMemberNo(c.memberNo || "-");
                                                setCustomerDOB(c.dob ? new Date(c.dob).toLocaleDateString() : "-");
                                                setCustomerMargin(c.margin || 0);
                                            }}>
                                                {c.name || "Unknown"} <span style={{ color: "#666", fontSize: "12px" }}>({c.phoneNumber})</span>
                                                {c.city && <span style={{ color: "#666", fontSize: "12px" }}> - {c.city}</span>}
                                            </div>
                                        ))}
                                    
                                    {customers.filter((c) => {
                                        const search = customerSearch.toLowerCase();
                                        return (c?.name?.toLowerCase().includes(search) || String(c?.phoneNumber || "").includes(search));
                                    }).length === 0 && (
                                            <div className="pos-dropdown-item no-results" onClick={() => setShowAddCustomerModal(true)} style={{ cursor: "pointer", fontWeight: "600" }}>
                                                + Add Customer
                                            </div>
                                        )}
                                    {showAddCustomerModal && (
                                        <div className="modal-overlay"><div className="modal">
                                            <AddCustomerForm isEditMode={false} onSuccess={() => setShowAddCustomerModal(false)} onCancel={() => setShowAddCustomerModal(false)} />
                                        </div></div>
                                    )}
                                </div>
                            )}

                            <div className="pos-divider"></div>
                            <div className="info-block" style={{ position: "relative" }}>
                                <div className="form-group">
                                    <label>Location</label>
                                    <input value={customerAddress} readOnly />
                                </div>
                                <div className="form-group">
                                    <label>Sales By</label>
                                    <select
                                        className="form-group1"
                                        value={salesBy}
                                        onChange={(e) => setSalesBy(e.target.value)}
                                    >
                                        <option value="">Select Sales By</option>

                                        {employees.map((emp) => (
                                            <option key={emp._id} value={emp._id}>
                                                {emp.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="card-divider"></div>
                        {/* Product Search */}
                        <div className="tag-inputs" ref={dropdownRef} style={{ position: "relative", display: "flex", gap: "10px" }}>
                            <label>Product Code:</label>
                            <input
                                type="text"
                                className="barcode-input"
                                placeholder="Search ProductCode / Product"
                                value={productSearch}
                                disabled={enableInvoiceInput}
                                onChange={(e) => handleBarcodeTyping(e.target.value)}
                                onFocus={() => setShowProductDropdown(true)}
                                style={{ width: "200px", padding: "8px" }}
                            />
                            {showProductDropdown && (
                                <div style={{
                                    position: "absolute", top: "40px", width: "430px", background: "#fff", border: "1px solid #ddd",
                                    borderRadius: "6px", maxHeight: "200px", overflowY: "auto", zIndex: 1000
                                }}>
                                    {filteredProducts.length > 0 ? (
                                        filteredProducts.map((p, i) => (
                                            <div key={i} style={{ padding: "8px", cursor: "pointer", borderBottom: "1px solid #eee" }}
                                                onClick={() => handleProductSelect(p)}>
                                                {p.productCode} — {p.title}
                                            </div>
                                        ))
                                    ) : (<div style={{ padding: "8px" }}>No Product Found</div>)}
                                </div>
                            )}
                        </div>

                        {/* Table Header & Body */}
                        <table className="pos-table">
                            <thead>
                                <tr>
                                    <th>Code</th><th>Product name</th><th>Unit</th><th>QTY</th><th>Rate</th><th>Discount Type(% or ₹)</th><th>Discount Value</th><th>Value</th><th>Remove</th>
                                </tr>
                            </thead>
                            <tbody>
                                {cartItems.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.barcode}</td>
                                        <td>{item.name}
                                            {item.offerApplied && (
                                                <span style={{
                                                    marginLeft: "4px",
                                                    background: "#e67e22",
                                                    color: "#fff",
                                                    padding: "2px 4px",
                                                    borderRadius: "3px",
                                                    fontSize: "10px",
                                                    fontWeight: "bold"
                                                }}>
                                                    {item.offerApplied}
                                                </span>
                                            )}
                                        </td>
                                        <td>{item.unit}</td>
                                        <td><input className="quantity-input" type="number" value={item.qty} onChange={(e) => updateQty(index, e.target.value)} style={{ width: "30px" }} /></td>
                                        <td>{item?.rate}</td>
                                        <td>
                                            <select className="disc-input" value={item.discType} onChange={(e) => updateDiscType(index, e.target.value)}>
                                                <option value="%">%</option>
                                                <option value="₹">₹</option>
                                            </select>
                                        </td>
                                        <td><input className="discValue-input" type="number" value={item.disc} onChange={(e) => updateDisc(index, e.target.value)} style={{ width: "50px" }} /></td>
                                        <td>{Number(item?.value || 0).toFixed(2)}</td>
                                        <td style={{ color: "red", fontWeight: "bold", cursor: "pointer", fontSize: "18px", textAlign: "center" }} onClick={() => removeCartItem(index)}>✕</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        {offerMessage && (
                            <div style={{
                                background: "#2ecc71",
                                color: "white",
                                padding: "10px",
                                borderRadius: "5px",
                                marginBottom: "10px",
                                fontWeight: "600",
                                textAlign: "center",
                                animation: "fadeIn 0.3s"
                            }}>
                                {offerMessage}
                            </div>
                        )}
                        <div className="card-divider"></div>

                        {/* Totals */}
                        <div className="summary-row">
                            <div className="summary-left">
                                <div className="item-values">
                                    <p>Items: {totals.items}</p>
                                    <p>QTY: {totals.qty}</p>
                                    <p>CGST: {totals.totalCGST.toFixed(2)}</p>
                                    <p>SGST: {totals.totalSGST.toFixed(2)}</p>
                                </div>
                                <div className="charge-rows">
                                    <div className="charge-row">
                                        OverAll Disc Type
                                        <select className="disc-input" value={overallDiscountType} onChange={(e) => setOverallDiscountType(e.target.value)}>
                                            <option value="%">%</option>
                                            <option value="₹">₹</option>
                                        </select>
                                    </div>
                                    <div className="charge-row">
                                        Add Discount
                                        <input type="number" className="quantity-input" style={{ width: "50px" }} value={overallDiscount} onChange={(e) => setOverallDiscount(e.target.value)} />
                                    </div>
                                </div>
                            </div>
                            <div className="summary-right">
                                <div className="net-box">{Number(totals.netValue || 0).toFixed(2)}</div>
                            </div>
                        </div>

                        {/* Buttons */}
                        <div className="btn-row">
                            <button className="btn-pos btn-print" onClick={handleOkPrint}>
                                <i className="fa fa-print" /> OK + Print
                            </button>

                            <button className="btn-pos btn-return" onClick={() => setReturnPanelOpen(true)}>
                                <i className="fa fa-undo" /> Return
                            </button>

                            <button className="btn-pos btn-clear" onClick={() => setCartItems([])}>
                                <i className="fa fa-trash" /> Clear
                            </button>

                            <button className="btn-pos btn-price" onClick={() => setShowPriceCheck(true)}>
                                <i className="fa fa-tag" /> Price Check
                            </button>

                            <button className="btn-pos btn-stock" onClick={() => setShowStockCheck(true)}>
                                <i className="fa fa-cubes" /> Stock Check
                            </button>

                            <button className="btn-pos btn-reprint" onClick={() => setShowReprintModal(true)}>
                                <i className="fa fa-copy" /> Reprint
                            </button>
                        </div>

                        {/* <div className="btn-row">
                            <button className="btn-primary" onClick={handleOkPrint}>OK + Print</button>
                            <button className="btn-danger" onClick={() => setReturnPanelOpen(true)}>Return</button>
                            <button className="btn-cancel" onClick={handleCancelBill}>Cancel Bill</button>
                            <button className="btn-light" onClick={() => setCartItems([])}>Clear</button>
                            <button className="btn-info" onClick={() => setShowPriceCheck(true)}>Price Check</button>
                            <button className="btn-info" onClick={() => setShowStockCheck(true)}>Stock Check</button>
                            <button className="btn-warning" onClick={() => setShowRedeemModal(true)}>Redeem Points</button>
                            <button className="btn-dark" onClick={() => setShowReprintModal(true)}>Reprint</button>
                        </div> */}
                    </div>

                    {/* RIGHT SIDE */}
                    <div className="pos-right">
                        <div className="card">
                            <h4>Previous Bill details</h4>
                            <div className="previous-bill-header"><div>Bill Date</div><div>Bill Number</div><div>Bill Value</div></div>
                            <div className="previous-bill-container">
                                {previousBills.length === 0 ? <p className="no-bills">No previous bills</p> : (
                                    <div className="full-scroll-box">
                                        {previousBills.map((b, i) => (
                                            <div key={i} className="previous-bill-row">
                                                <div className="bill-cell">{new Date(b.createdAt).toLocaleDateString()}</div>
                                                <div className="bill-cell">{b.invoiceNo}</div>
                                                <div className="bill-cell">₹{b.totals.netValue.toFixed(2)}</div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                            <div className="card-divider"></div>
                            <div className="customer-info-box">
                                <div className="info-row">Total MRP Value <span>₹{totals.totalMRP.toFixed(2)}</span></div>
                                <div className="info-row">Your Saving MRP <span>₹{totals.saving.toFixed(2)}</span></div>
                                <div className="info-row">Customer Bal Amt <span>{customerBalance}</span></div>
                                <div className="info-row">Total sales Value <span>₹{totals.netValue.toFixed(2)}</span></div>
                                <div className="info-row">Available Points <span>{availablePoints}</span></div>
                                <div className="info-row">Customer Mob <span>{customerMobile}</span></div>
                                <div className="info-row">Customer Mem NO <span>-</span></div>
                                <div className="info-row">Customer DOB <span>-</span></div>
                                <div className="info-row">Customer Margin % <span>0.00</span></div>
                            </div>
                        </div>
                    </div>

                    {/* {showPaymentModal && (
                        <div className="payment-overlay">
                            <div className="payment-box">
                                <h2>Complete Payment</h2>
                                <p style={{ marginBottom: "10px" }}>Net Amount: <strong>₹{totals.netValue.toFixed(2)}</strong></p>

                                {payments.map((p, index) => (
                                    <div key={index} className="payment-row">
                                        <select value={p.paymentMethod} onChange={(e) => {
                                            const update = [...payments];
                                            update[index].paymentMethod = e.target.value;
                                            setPayments(update);
                                        }}>
                                            <option value="Cash">Cash</option>
                                            <option value="Card">Card</option>
                                            <option value="UPI">UPI</option>
                                            <option value="Wallet">Wallet</option>
                                        </select>
                                        <input type="text" placeholder="Amount" value={p.amount} onChange={(e) => {
                                            const update = [...payments];
                                            update[index].amount = Number(e.target.value);
                                            setPayments(update);
                                        }} />
                                        {payments.length > 1 && <button className="remove-btn" onClick={() => setPayments(payments.filter((_, i) => i !== index))}>✕</button>}
                                    </div>
                                ))}

                                <button className="add-method-btn" onClick={() => setPayments([...payments, { paymentMethod: "Cash", amount: 0 }])}>+ Add Payment Method</button>

                                <p style={{ marginTop: "10px" }}>Total Received: <strong>₹{payments.reduce((sum, p) => sum + Number(p.amount || 0), 0)}</strong></p>

                                {payments.reduce((sum, p) => sum + Number(p.amount || 0), 0) !== totals.netValue && (
                                    <p style={{ color: "red" }}>Payment amount must match bill total.</p>
                                )}

                                <div className="payment-actions">
                                    <button className="cancel-payment-btn" onClick={() => setShowPaymentModal(false)}>Cancel</button>
                                    <button className="confirm-payment-btn" disabled={payments.reduce((sum, p) => sum + Number(p.amount || 0), 0) !== totals.netValue} onClick={handleCreateInvoice}>Confirm & Print</button>
                                </div>
                            </div>
                        </div>
                    )} */}
                    {showPaymentModal && (
                    <div className="payment-overlay">
                        <div className="payment-box">
                            <h2>Complete Payment</h2>

                            {/* Original Net */}
                            <p>
                                Bill Amount:
                                <strong> ₹{totals.netValue.toFixed(2)}</strong>
                            </p>

                            {/* 🎁 Reward Redeem Section */}
                            {selectedCustomer && availablePoints > 0 && (
                                <div style={{
                                    border: "1px dashed #ccc",
                                    padding: "10px",
                                    borderRadius: "6px",
                                    marginBottom: "10px"
                                }}>
                                    <label style={{ display: "flex", gap: "6px", alignItems: "center" }}>
                                        <input
                                            type="checkbox"
                                            checked={useRewardPoints}
                                            onChange={(e) => {
                                                setUseRewardPoints(e.target.checked);
                                                if (!e.target.checked) setRedeemPoints(0);
                                            }}
                                        />
                                        Redeem Reward Points
                                    </label>

                                    <p style={{ fontSize: 12 }}>
                                        Available Points: <b>{availablePoints}</b>
                                    </p>

                                    {useRewardPoints && (
                                        <>
                                            <input
                                                type="number"
                                                min="0"
                                                max={maxRedeemablePoints}
                                                value={redeemPoints}
                                                onChange={(e) => {
                                                    const val = Number(e.target.value || 0);
                                                    setRedeemPoints(Math.min(val, maxRedeemablePoints));
                                                }}
                                                placeholder="Enter points"
                                                style={{ width: "100%", marginTop: 6 }}
                                            />

                                            <p style={{ fontSize: 12, marginTop: 6 }}>
                                                Redeem Amount: ₹{redeemAmount}
                                            </p>
                                        </>
                                    )}
                                </div>
                            )}

                            {selectedCustomer && customerBalance > 0 && (
                            <div style={{
                                border: "1px dashed #4caf50",
                                padding: "10px",
                                borderRadius: "6px",
                                marginBottom: "10px"
                            }}>
                                <p style={{ fontSize: 13 }}>
                                    Wallet Balance: <b>₹{customerBalance.toFixed(2)}</b>
                                </p>
                                <p style={{ fontSize: 13 }}>
                                    Wallet Used: <b>₹{walletUsed.toFixed(2)}</b>
                                </p>
                                <p style={{ fontSize: 13 }}>
                                    Balance After: <b>₹{(customerBalance - walletUsed).toFixed(2)}</b>
                                </p>
                            </div>
                            )}

                            {/* Final Payable */}
                            <p>
                                Payable Amount:
                                <strong> ₹{payableAmount.toFixed(2)}</strong>
                            </p>

                            {/* Payment Methods */}
                            {payments.map((p, index) => (
                                <div key={index} className="payment-row">
                                    <select
                                        value={p.paymentMethod}
                                        onChange={(e) => {
                                            const update = [...payments];
                                            update[index].paymentMethod = e.target.value;
                                            setPayments(update);
                                        }}
                                    >
                                        <option value="Cash">Cash</option>
                                        <option value="Card">Card</option>
                                        <option value="UPI">UPI</option>
                                        <option value="Wallet">Wallet</option>
                                    </select>

                                    {/* <input
                                        type="number"
                                        placeholder="Amount"
                                        value={p.amount}
                                        onChange={(e) => {
                                            const update = [...payments];
                                            update[index].amount = Number(e.target.value || 0);
                                            setPayments(update);
                                        }}
                                    /> */}
                                    <input
                                        type="number"
                                        placeholder="Amount"
                                        value={p.amount}
                                        disabled={p.paymentMethod === "Wallet"}
                                        onChange={(e) => {
                                            if (p.paymentMethod === "Wallet") return;

                                            const update = [...payments];
                                            update[index].amount = Number(e.target.value || 0);
                                            setPayments(update);
                                        }}
                                    />

                                    {payments.length > 1 && (
                                        <button
                                            className="remove-btn"
                                            onClick={() =>
                                                setPayments(payments.filter((_, i) => i !== index))
                                            }
                                        >
                                            ✕
                                        </button>
                                    )}
                                </div>
                            ))}

                            <button
                                className="add-method-btn"
                                onClick={() =>
                                    setPayments([...payments, { paymentMethod: "Cash", amount: 0 }])
                                }
                            >
                                + Add Payment Method
                            </button>

                            {/* Validation */}
                            <p style={{ marginTop: 10 }}>
                                Total Received:
                                <strong>
                                    ₹{payments.filter(p => p.paymentMethod !== "Wallet").reduce((s, p) => s + Number(p.amount || 0), 0)}
                                </strong>
                            </p>

                            {payments.filter(p => p.paymentMethod !== "Wallet").reduce((s, p) => s + Number(p.amount || 0), 0) !== payableAmount && (
                                <p style={{ color: "red" }}>
                                    Payment must match payable amount.
                                </p>
                            )}

                            <div className="payment-actions">
                                <button
                                    className="cancel-payment-btn"
                                    onClick={() => setShowPaymentModal(false)}
                                >
                                    Cancel
                                </button>

                                <button
                                    className="confirm-payment-btn"
                                    disabled={
                                        payments.filter(p => p.paymentMethod !== "Wallet").reduce((s, p) => s + Number(p.amount || 0), 0) !== payableAmount
                                    }
                                    onClick={handleCreateInvoice}
                                >
                                    Confirm & Print
                                </button>
                            </div>
                        </div>
                    </div>
                )}
                </div>
            </div>

            <div id="invoice-print-area" style={{ display: "none" }}>
                <InvoicePrint58 invoice={printInvoice} />
            </div>

            <div id="return-print-area" style={{ display: "none" }}>
                <ReturnPrint58 data={returnPrintData} />
            </div>

            {showPricePopup && (
            <div className="modal-overlay">
                <div
                    className="modal-box"
                    style={{
                        width: 360,
                        borderRadius: 12,
                        padding: 16
                    }}
                    >
                    {/* Header */}
                    <div style={{ marginBottom: 12 }}>
                        <h3 style={{ margin: 0 }}>Select Selling Price</h3>
                        <p style={{ fontSize: 12, color: "#666", marginTop: 4 }}>
                        Choose price based on available stock
                        </p>
                    </div>

                    {/* Price Options */}
                    <div style={{ maxHeight: 260, overflowY: "auto" }}>
                        {stockOptions.map((option, index) => (
                        <div
                            key={index}
                            onClick={() => {
                                const fifoStock = option.stocks
                                    .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))[0];

                                addProductToCartWithStock(selectedProduct, fifoStock);
                                setShowPricePopup(false);
                            }}
                            style={{
                            border: "1px solid #e0e0e0",
                            borderRadius: 10,
                            padding: "12px 14px",
                            marginBottom: 10,
                            cursor: "pointer",
                            background: "#fff",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            transition: "all 0.2s ease"
                            }}
                            onMouseEnter={(e) => {
                            e.currentTarget.style.background = "#f9f9f9";
                            e.currentTarget.style.borderColor = "#8D2629";
                            }}
                            onMouseLeave={(e) => {
                            e.currentTarget.style.background = "#fff";
                            e.currentTarget.style.borderColor = "#e0e0e0";
                            }}
                        >
                            {/* Left: Price */}
                            <div>
                            <div style={{ fontSize: 16, fontWeight: 700 }}>
                                ₹{option.sellingPrice}
                            </div>
                            <div style={{ fontSize: 11, color: "#777" }}>
                                Batches: {option.stocks.length}
                            </div>
                            </div>

                            {/* Right: Qty Badge */}
                            <div
                            style={{
                                background: "#E6CF80",
                                color: "#000",
                                borderRadius: 20,
                                padding: "4px 10px",
                                fontSize: 12,
                                fontWeight: 600,
                                minWidth: 90,
                                textAlign: "center"
                            }}
                            >
                            Qty {option.totalQty}
                            </div>
                        </div>
                        ))}
                    </div>

                    {/* Footer */}
                    <button
                        onClick={() => setShowPricePopup(false)}
                        style={{
                        marginTop: 12,
                        width: "100%",
                        padding: "8px 0",
                        borderRadius: 8,
                        border: "none",
                        background: "#ccc",
                        fontWeight: 600,
                        cursor: "pointer"
                        }}
                    >
                        Cancel
                    </button>
                </div>
            </div>
            )}
            
            { returnPanelOpen && (
            <div className="return-modal-overlay">

                <div className="return-modal-box">

                    {/* Header */}
                    <div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                        <div>
                            <h3 style={{margin:0}}>Return / Refund</h3>
                            <div style={{fontSize:12, color:"#666"}}>Simple item-wise returns (rate × qty)</div>
                        </div>
                        <button 
                            className="btn-cancel"
                            onClick={() => {
                                setReturnPanelOpen(false);
                                setReturnInvoiceNo("");
                                setReturnInvoice(null);
                                setReturnRemarks("");
                            }}
                        >
                            ✕
                        </button>
                    </div>

                    {/* Invoice Fetch */}
                    <div style={{display:'flex', gap:8, marginTop:15}}>
                        <input
                            className="form-control"
                            placeholder="Enter Invoice Number"
                            value={returnInvoiceNo}
                            onChange={(e) => setReturnInvoiceNo(e.target.value)}
                            style={{flex:1}}
                        />
                        <button className="btn-primary" onClick={loadReturnInvoice} disabled={returnLoading}>
                            {returnLoading ? "Loading..." : "Fetch"}
                        </button>
                    </div>

                    {/* Helper Box */}
                    {!returnInvoice && (
                        <div style={{
                            padding:10, 
                            marginTop:10,
                            background:'#f6f6f6',
                            borderRadius:6,
                            fontSize:13,
                            color:'#555'
                        }}>
                            Enter invoice no and click Fetch to load items for return.
                        </div>
                    )}

                    {/* Items Section */}
                    {returnInvoice && (
                        <>
                            <h4 style={{marginTop:15}}>
                                Invoice: {returnInvoice.invoiceNo}
                            </h4>

                            <table className="return-table">
                                <thead>
                                    <tr>
                                        <th>Item</th>
                                        <th>Sold</th>
                                        <th>Returned</th>
                                        <th>Remaining</th>
                                        <th>Return</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {returnInvoice.items.map((item, i) => {
                                        const remaining = item.qty - (item.returnedQty || 0);

                                        return (
                                            <tr key={i}>
                                                <td>{item.name}</td>
                                                <td>{item.qty}</td>
                                                <td>{item.returnedQty || 0}</td>
                                                <td>{remaining}</td>
                                                <td>
                                                    <input
                                                        type="number"
                                                        min="0"
                                                        max={remaining}
                                                        value={item.qtyReturned || ""}
                                                        onChange={(e) => {
                                                            const val = Number(e.target.value);

                                                            if (val > remaining) return toast.error("Exceeded remaining quantity");

                                                            setReturnInvoice(prev => {
                                                                const copy = { ...prev };
                                                                copy.items[i].qtyReturned = val;
                                                                return copy;
                                                            });
                                                        }}
                                                    />
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>

                            {/* Remarks */}
                            <textarea
                                className="form-control"
                                placeholder="Remarks (optional)"
                                value={returnRemarks}
                                onChange={(e) => setReturnRemarks(e.target.value)}
                                style={{marginTop:10}}
                            />

                            {/* Preview Button */}
                            <button
                            className="btn-light"
                            onClick={handlePreviewReturn}
                            style={{ marginTop: 10, width: '100%' }}
                            disabled={previewLoading}
                            >
                            {previewLoading ? "Previewing..." : "Preview Return"}
                            </button>

                            {/* Preview Section */}
                            {previewData && (
                            <div className="return-preview-box">
                                <h4>Return Preview</h4>

                                <div className="preview-row">
                                    <span>Item Value</span>
                                    <strong>₹ {previewData.itemValue.toFixed(2)}</strong>
                                </div>

                                {previewData.rewardReversal > 0 && (
                                <div className="preview-row warning">
                                    <span>Reward Used in Invoice</span>
                                    <strong>- ₹ {previewData.rewardReversal.toFixed(2)}</strong>
                                </div>
                                )}

                                <hr />

                                <div className="preview-row total">
                                    <span>Refund Amount</span>
                                    <strong>₹ {previewData.finalRefund.toFixed(2)}</strong>
                                </div>

                                <div className="preview-note">
                                    Refund will be credited to customer wallet
                                </div>
                            </div>
                            )}

                            {/* Process Button */}
                            <button
                            className="btn-process"
                            onClick={processReturn}
                            style={{ marginTop: 12, width: '100%' }}
                            disabled={!previewData}
                            >
                            Process Return
                            </button>
                        </>
                    )}
                </div>
            </div>
            )}

            {pricePopup && (
                <div className="price-popup-overlay">
                    <div className="price-popup-box">
                        <h3>Select Price for {pricePopup.product.title}</h3>
                        <table className="price-popup-table">
                            <thead><tr><th>Date</th><th>Price</th><th>Select</th></tr></thead>
                            <tbody>
                                {pricePopup.entries.map((e, i) => (
                                    <tr key={i}>
                                        <td>{new Date(e.createdAt).toLocaleDateString()}</td>
                                        <td>₹{e.sellingPrice}</td>
                                        <td>
                                            <button onClick={() => {
                                                addRowsToCart([{
                                                    productId: pricePopup.product._id,
                                                    barcode: pricePopup.product.productCode,
                                                    name: pricePopup.product.title,
                                                    unit: pricePopup.product.unit || "PCS",
                                                    qty: 1,
                                                    rate: e.sellingPrice,
                                                    tax: pricePopup.product.tax || 0,
                                                    discType: "%",
                                                    disc: 0,
                                                    value: e.sellingPrice,
                                                    isFree: false
                                                }]);
                                                setPricePopup(null);
                                            }}>Choose</button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <button className="popup-close" onClick={() => setPricePopup(null)}>Cancel</button>
                    </div>
                </div>
            )}

            {showPriceCheck && (
            <div className="modal-overlay">
                <div className="modal">
                <h3>Price Check</h3>

                <input
                    className="form-control"
                    placeholder="Enter Product ID"
                    value={priceCheckInput}
                    onChange={(e) => setPriceCheckInput(e.target.value)}
                    style={{ width: "95%" }}
                />

                {/* 🔘 ACTION BUTTONS */}
                <div className="action-buttons">
                    <button
                    className="btn-primary"
                    onClick={async () => {
                        setPriceCheckResult(null);
                        setPriceCheckError(null);

                        if (!priceCheckInput) return;

                        try {
                        const res = await getData(
                            `/products/price-check/${priceCheckInput}`
                        );

                        if (res.success) {
                            setPriceCheckResult(res.data);
                        } else {
                            setPriceCheckError(res.message || "Product out of stock");
                        }
                        } catch {
                        setPriceCheckError("Product out of stock");
                        }
                    }}
                    >
                    Check
                    </button>

                    <button
                    className="btn-secondary"
                    onClick={() => {
                        setShowPriceCheck(false);
                        setPriceCheckInput("");
                        setPriceCheckResult(null);
                        setPriceCheckError(null);
                    }}
                    >
                    Close
                    </button>
                </div>

                {/* ❌ ERROR MESSAGE */}
                {priceCheckError && (
                    <p className="error-text">{priceCheckError}</p>
                )}

                {/* ✅ PRICE-WISE RESULT (CARD UI) */}
                {priceCheckResult?.priceWiseStock?.length > 0 && (
                    <div className="price-card-wrapper">
                    {priceCheckResult.priceWiseStock.map((item, index) => (
                        <div className="price-card" key={index}>
                        <div className="price-header">
                            ₹{item.sellingPrice}
                        </div>

                        <div className="price-body">
                            <div className="total">
                            <span>Available Stock</span>
                            <b>{item.stock}</b>
                            </div>
                        </div>
                        </div>
                    ))}
                    </div>
                )}
                </div>
            </div>
            )}

            {showStockCheck && (
            <div className="modal-overlay">
                <div className="modal">
                <h3>Stock Check</h3>

                <input
                    style={{ width: "95%" }}
                    className="form-control"
                    placeholder="Enter product code"
                    value={stockInput}
                    onChange={(e) => setStockInput(e.target.value)}
                />

                {/* 🔘 ACTION BUTTONS */}
                <div className="action-buttons">
                    <button
                    className="btn-primary"
                    onClick={async () => {
                        setStockResult(null);
                        setStockError(null);

                        if (!stockInput) return;

                        try {
                        const res = await getData(`/products/price-wise/${stockInput}`);
                        if (res.success) {
                            setStockResult(res);
                        } else {
                            setStockError(res.message || "Product out of stock");
                        }
                        } catch {
                        setStockError("Product out of stock");
                        }
                    }}
                    >
                    Search
                    </button>

                    <button
                    className="btn-secondary"
                    onClick={() => {
                        setShowStockCheck(false);
                        setStockInput("");
                        setStockResult(null);
                        setStockError(null);
                    }}
                    >
                    Close
                    </button>
                </div>

                {/* ❌ ERROR MESSAGE */}
                {stockError && (
                    <p className="error-text">{stockError}</p>
                )}

                {/* ✅ PRICE-WISE STOCK CARDS */}
                {stockResult?.priceWiseStock?.length > 0 && (
                    <div className="price-card-wrapper">
                    {stockResult.priceWiseStock.map((p, i) => (
                        <div className="price-card" key={i}>
                        <div className="price-header">
                            ₹{p.sellingPrice}
                        </div>

                        <div className="price-body">
                            <div>
                            <span>Offline</span>
                            <b>{p.offlineQuantity}</b>
                            </div>
                            <div>
                            <span>Online</span>
                            <b>{p.onlineQuantity}</b>
                            </div>
                            <div className="total">
                            <span>Total</span>
                            <b>{p.totalStock}</b>
                            </div>
                        </div>
                        </div>
                    ))}
                    </div>
                )}

                {/* ❌ OUT OF STOCK */}
                {stockResult && !stockError && stockResult.priceWiseStock?.length === 0 && (
                    <p className="error-text">Product out of stock</p>
                )}
                </div>
            </div>
            )}

            {/* {showRedeemModal && (
                <div className="modal-overlay">
                    <div className="modal">
                        <h3>Redeem Points</h3>

                        <p>Available: <b>{customerPoints}</b></p>

                        <input
                            type="number"
                            value={redeemPoints}
                            onChange={(e) => setRedeemPoints(e.target.value)}
                        />

                        <button onClick={() => {
                            const discount = Number(redeemPoints) * 1; // 1 point = ₹1
                            setOverallDiscountType("₹");
                            setOverallDiscount(discount);
                            setShowRedeemModal(false);
                        }}>Apply</button>

                        <button onClick={() => setShowRedeemModal(false)}>Close</button>
                    </div>
                </div>
            )} */}

            {showReprintModal && (
            <div className="modal-overlay">
                <div className="modal">
                <h3>Reprint Invoice</h3>

                <input
                    className="form-control"
                    placeholder="Enter Invoice No"
                    value={reprintInput}
                    onChange={(e) => setReprintInput(e.target.value)}
                />

                <div className="action-buttons">
                    <button
                    className="btn-primary"
                    onClick={async () => {
                        if (!reprintInput) return;

                        const res = await getData(`/invoices/reprint/${reprintInput}`);

                        if (res.success) {
                        // ✅ add duplicate flag
                            setPrintInvoice({
                                ...res.data,
                                isDuplicate: true
                            });
                            setShouldPrint(true);
                            setShowReprintModal(false);
                        }
                    }}
                    >
                    Reprint
                    </button>

                    <button
                    className="btn-secondary"
                    onClick={() => setShowReprintModal(false)}
                    >
                    Close
                    </button>
                </div>
                </div>
            </div>
            )}
        </div>
    );
};

export default POSPage;

